let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("104CE")).then(() => parcelRequire('01Oij'));